import { inject } from '@angular/core'
import {
  CanActivateChildFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router'
import { Store } from '@ngxs/store'
import { AuthState } from '../stores/auth/auth.state'
import { AuthService } from '../services/auth.service'

export const authGuard: CanActivateChildFn = (
  route,
  state: RouterStateSnapshot
) => {
  const isAuthenticated = inject(Store).selectSnapshot(
    AuthState.getIsAuthenticated
  )
  const router = inject(Router)

  if (inject(AuthService).isLoggedIn()) return true

  if (!isAuthenticated) {
    // Sauvegarder l'URL de retour pour rediriger après connexion
    const returnUrl = state.url
    router.navigate(['/login'], { queryParams: { returnUrl } })
    return false
  }
  return true
}
